import { action, observable } from 'mobx'
import { BoardResolutionMinutesRequest } from '../requests/BoardResolutionMinutesRequest'

class boardResolutionMinutesStore {
  // Observables
  @observable filterBoardHDQT = {
    isOpen: false,
    page: 1,
    size: 10,
    contruction_board: '',
    document_name: '',
    document_number: '',
    from_issue_date: '',
    to_issue_date: '',
    status: undefined,
    issue_level: '',
  }

  @observable listBoardHDQT = []
  @observable BoardHDQTDetail = {}

  // Actions
  getBoardResolutionMinutes = payload => {
    return new Promise((resolve, reject) => {
      BoardResolutionMinutesRequest.getBoardResolutionMinutes(payload)
        .then(response => {
          this.totalCount = response.data.total_count
          this.listBoardHDQT = response.data.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getBoardResolutionMinutesDetail = payload => {
    return BoardResolutionMinutesRequest.getBoardResolutionMinutesDetail(
      payload
    ).then(response => {
      this.BoardHDQTDetail = response.data
      return response
    })
  }

  createBoardResolutionMinutes = payload => {
    return BoardResolutionMinutesRequest.createBoardResolutionMinutes(payload)
  }

  updateBoardResolutionMinutes = (id, payload) => {
    return BoardResolutionMinutesRequest.updateBoardResolutionMinutes(
      id,
      payload
    ).then(response => {
      this.VBPCDetail = response.data
      return response
    })
  }

  deleteBoardResolutionMinutes = id => {
    return BoardResolutionMinutesRequest.deleteBoardResolutionMinutes(id)
  }

  getAttachmentBoardHDQT = payload => {
    return BoardResolutionMinutesRequest.getAttachmentBoardHDQT(payload)
  }

  getviewBoardFile = payload => {
    return BoardResolutionMinutesRequest.getviewBoardFile(payload).then(
      response => {
        this.attachment = new Blob([response.data], { type: 'application/pdf' })
        return response
      }
    )
  }

  setfilterBoardHDQT = filter => {
    this.filterBoardHDQT = { ...this.filterBoardHDQT, ...filter }
  }

  resetFilter = () => {
    this.filterBoardHDQT = {
      isOpen: false,
      page: 1,
      size: 10,
      contruction_board: '',
      document_name: '',
      document_number: '',
      from_issue_date: '',
      to_issue_date: '',
      status: undefined,
      issue_level: '',
    }
  }

  clearDocument = () => {
    this.listBoardHDQT = []
    this.totalCount = 0
  }

  clearBoardHDQTDetail = () => {
    this.BoardHDQT = {}
    this.attachment = undefined
  }
}

export default new boardResolutionMinutesStore()
